import { Box } from "@mui/material";
import FormulaScorer from "../components/FormulaScorer";

export default function FormulaScorerPage() {
  return (
    <Box sx={{ padding: "8px 0" }}>
      <FormulaScorer />
    </Box>
  );
}
